import { getErrorMessage } from '../../shared/errorMessage';

/** Evita `new Error({…})` → mensaje "[object Object]". */
export function resolveBarcodeLookupHttpError(body: unknown, fallback: string): string {
  if (!body || typeof body !== 'object') return fallback;
  const err = (body as { error?: unknown }).error;
  if (typeof err === 'string' && err.trim()) return err.trim();
  return getErrorMessage(err, fallback);
}
